// extracted by mini-css-extract-plugin
export default {"headerIcon":"renderUtils_headerIcon__Zhklw","sectionHeader":"renderUtils_sectionHeader__4gwQf"};